import React, { SVGProps } from 'react';

const GameShowsIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M2 5.21387C2 4.1093 2.89543 3.21387 4 3.21387H16C17.1046 3.21387 18 4.1093 18 5.21387V11.3503C18 11.9164 17.7601 12.456 17.3399 12.8352L15.1429 14.8176L12.2835 17.372C11.9169 17.6995 11.4426 17.8805 10.951 17.8805H4C2.89543 17.8805 2 16.9851 2 15.8805V5.21387Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default GameShowsIcon;
